import React from 'react';
import { Button } from '../ui/button';
import FundingAIRecommendationBadge from './FundingAIRecommendationBadge';

const FundingAIRecommendationCard = ({
  recommendation,
  onAccept,
  onDismiss,
  onComplete,
  saving = false,
}) => {
  if (!recommendation) return null;

  return (
    <div className="rounded-2xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] p-4">
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div>
          <div className="font-semibold text-[var(--fg-text)]">{recommendation.title}</div>
          <div className="mt-1 text-sm text-[var(--fg-muted)]">{recommendation.summary}</div>
        </div>
        <div className="flex flex-wrap gap-2">
          <FundingAIRecommendationBadge priority={recommendation.priority} />
          <FundingAIRecommendationBadge category={recommendation.category} />
        </div>
      </div>
      <div className="mt-3 text-sm text-[var(--fg-text)]">
        <span className="font-medium text-[var(--fg-accent)]">Recommended action: </span>
        {recommendation.suggestedAction}
      </div>
      {recommendation.advisorNote ? (
        <div className="mt-2 text-xs text-[var(--fg-muted)]">
          Advisor note: {recommendation.advisorNote}
        </div>
      ) : null}
      {recommendation.status === 'Open' ? (
        <div className="mt-3 flex flex-wrap gap-2">
          <Button size="sm" className="rounded-xl" disabled={saving} onClick={() => onAccept?.(recommendation)}>
            Accept
          </Button>
          <Button size="sm" variant="outline" className="rounded-xl" disabled={saving} onClick={() => onDismiss?.(recommendation)}>
            Dismiss
          </Button>
          <Button size="sm" variant="ghost" className="rounded-xl" disabled={saving} onClick={() => onComplete?.(recommendation)}>
            Mark complete
          </Button>
        </div>
      ) : (
        <div className="mt-3 text-xs font-medium text-[var(--fg-muted)]">Status: {recommendation.status}</div>
      )}
    </div>
  );
};

export default FundingAIRecommendationCard;
